import React, { useEffect, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { API_CREATE_STORE } from "api/store-managemnt";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import axios, { Axios } from "axios";
import { CONSTANTS } from "config/constant";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import { useTranslation } from "react-i18next";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_CREATE_LAUNDRY_BOX } from "api/laundrybox-management";
import { API_UPDATE_LAUNDRY_BOX } from "api/laundrybox-management";
import { MdOutlineArrowBack } from "react-icons/md";

const EditLaundryBox = () => {
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const Navigate = useNavigate();
  const location = useLocation();
  const box = location.state && location.state.data;
  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`
      );

      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`
      );

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", postalCode);
        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue("location", selectedAddress?.description);

        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);

        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_MAIN_LAUNDRY(params);
      console.log("provider", newData);
      setData(newData?.laundry);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            enableReinitialize
            initialValues={{
              name: box?.name,
              description: box?.description,
              // laundry: "661e73e27954ce542d5b6b23",
              laundry: box?.laundry,

              location: box?.location_details?.address,
              location_lat: box?.location_details?.latitude,
              location_lng: box?.location_details?.longitude,
              max_item_capacity: box?.max_item_capacity,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .required("Required")
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              location: Yup.string().required("Required"),
              max_item_capacity: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   const {
              //     location,
              //     address,
              //     location_lat,
              //     location_lng,
              //     ...storeData
              //   } = values;

              //   const payload = {
              //     ...storeData,
              //     location_details: {
              //       // lat_long: latLng,
              //       latitude: location_lat,
              //       longitude: location_lng,
              //       address: location,
              //     },
              //   };

              //   const userData = await API_UPDATE_LAUNDRY_BOX(
              //     payload,
              //     box?._id
              //   );

              //   toast.success(userData?.message);
              //   Navigate("/admin/laundry-box/laundry-box-tables");
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Name")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="name"
                        placeholder={t("Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Max Item Capacity")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Max Item Capacity")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="max_item_capacity"
                        placeholder={t("Max Item Capacity")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="max_item_capacity"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col xs={24} md={12} lg={12} className="">
                    {/* <label
                      for="floating_outlined"
                      className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                    >
                      {t("Location")}
                    </label> */}
                    <TextareaField
                      className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      label={t("Location")}
                      name="location"
                      placeholder={t("Location")}
                      value={values?.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue("location", addressInput);
                        searchAddress(addressInput); // Call the address autocomplete function
                      }}
                      // required
                    />
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestions.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestions}
                        // onSelectAddress={onSelectAddress}
                        onSelectAddress={(address) =>
                          onSelectAddress(address, setFieldValue)
                        }
                      />
                    )}
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Description")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Description")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* 
                  <Col span={8}>
                    <div className="mb-3">
                      <label>
                        Store location <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="location"
                        placeholder="Location"
                        handleChange={(e) => {
                          const addressInput = e.target.value;
                          console.log("addressInput",addressInput)
                          searchAddress(addressInput); // Call the address autocomplete function
                        }} // autoComplete="off"
                      />
                      {autocompleteSuggestions.length > 0 && (
                        <AddressAutocomplete
                          suggestions={autocompleteSuggestions}
                          onSelectAddress={onSelectAddress}
                        />
                      )}
                      <ErrorMessage
                        name="location"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[11rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting
                      ? t("Creating") + "..."
                      : t("Update Laundry Box")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const {
                  location,
                  address,
                  location_lat,
                  location_lng,
                  ...storeData
                } = valuesData;

                const payload = {
                  ...storeData,
                  location_details: {
                    // lat_long: latLng,
                    latitude: location_lat,
                    longitude: location_lng,
                    address: location,
                  },
                  geo: {
                    coordinates: [location_lat, location_lng],
                  },
                };

                const userData = await API_UPDATE_LAUNDRY_BOX(
                  payload,
                  box?._id
                );

                toast.success(userData?.message);
                Navigate("/admin/laundry-box/laundry-box-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const {
                        location,
                        address,
                        location_lat,
                        location_lng,
                        ...storeData
                      } = valuesData;

                      const payload = {
                        ...storeData,
                        location_details: {
                          // lat_long: latLng,
                          latitude: location_lat,
                          longitude: location_lng,
                          address: location,
                        },
                        geo: {
                          coordinates: [location_lat, location_lng],
                        },
                      };

                      const userData = await API_UPDATE_LAUNDRY_BOX(
                        payload,
                        box?._id
                      );

                      toast.success(userData?.message);
                      Navigate("/admin/laundry-box/laundry-box-tables");
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditLaundryBox;
